/**
 * Custom API Error class that extends Error
 * This ensures proper error handling with instanceof checks
 */
export class ApiError extends Error {
  public code: string;
  public details?: Record<string, unknown> | undefined;
  public timestamp: string;
  public status?: number | undefined;

  constructor(
    message: string,
    code: string,
    details?: Record<string, unknown>,
    status?: number
  ) {
    super(message);
    this.name = 'ApiError';
    this.code = code;
    this.timestamp = new Date().toISOString();

    // Conditionally assign optional properties to satisfy exactOptionalPropertyTypes
    if (details !== undefined) {
      this.details = details;
    }
    if (status !== undefined) {
      this.status = status;
    }

    // Maintain proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ApiError);
    }
  }

  /**
   * Convert to ErrorResponse format for backward compatibility
   */
  toErrorResponse() {
    return {
      code: this.code,
      message: this.message,
      details: this.details,
      timestamp: this.timestamp,
    };
  }
}
